import { RouteConfig } from 'vue-router'

const Index = () => import('../../views/activity/summer-friends-2023/Index.vue')
const Friends = () => import('../../views/activity/summer-friends-2023/Friends.vue')
const Rank = () => import('../../views/activity/summer-friends-2023/Rank.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/summer-friends-2023',
  name: 'summer_friends_2023',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
}

export const friendsRoute: RouteConfig = {
  path: '/activity/summer-friends-2023-friends',
  name: 'summer_friends_2023_friends',
  component: Friends,
  props: (route) => ({ ...route.query, ...route.params }),
}

export const rankRoute: RouteConfig = {
  path: '/activity/summer-friends-2023-rank',
  name: 'summer_friends_2023_rank',
  component: Rank,
  props: (route) => ({ ...route.query, ...route.params }),
}

export default [indexRoute, friendsRoute, rankRoute]
